var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"rn-service-area rn-section-gap  text-center",staticStyle:{"padding":"25px 0px 100px 0px"},attrs:{"id":"service"}},[_c('v-container',[_c('ServiceSix',{staticClass:"interior-services"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }